export default __webpack_public_path__ + "260f0766d14547aeebae7f765298c80e.png";